module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "category-wrapper"
  }, [_vm._l((_vm.catTree), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "category-item",
      class: _vm.categoryActiveIndex == index ? 'categoryActive' : ''
    }, [_c('el-image', {
      staticStyle: {
        "width": "24px",
        "margin-right": "22px"
      },
      attrs: {
        "fit": "cover",
        "src": item.image
      }
    }), _vm._v(" "), _c('el-breadcrumb', {
      attrs: {
        "separator": "/"
      },
      nativeOn: {
        "mouseenter": function($event) {
          return _vm.mouseEnter(item, index)
        }
      }
    }, _vm._l((item.children), function(cat2, cat2index) {
      return (cat2index < 3) ? _c('el-breadcrumb-item', {
        key: cat2.catId,
        staticClass: "category-item-content"
      }, [_c('router-link', {
        key: cat2.catId,
        attrs: {
          "to": {
            path: '/goods-list',
            query: {
              catname: cat2.name,
              cat_id: cat2.catId
            },
          },
          "target": "_blank"
        }
      }, [_vm._v("\n          " + _vm._s(cat2.name) + "\n        ")])], 1) : _vm._e()
    }), 1)], 1)
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "category-sub",
    style: ({
      left: _vm.rightW + 'px'
    })
  }, [_c('el-scrollbar', {
    staticStyle: {
      "height": "100%"
    }
  }, _vm._l((_vm.subList), function(item, index) {
    return _c('div', {
      key: item.catId,
      staticClass: "sub-item",
      class: _vm.hoverActiveIndex == index ? 'hoverActive' : '',
      on: {
        "mouseenter": function($event) {
          return _vm.mouseEnterSub(item, index)
        },
        "click": function($event) {
          return _vm.subHandler(item)
        }
      }
    }, [_vm._v("\n      " + _vm._s(item.name) + "\n    ")])
  }), 0)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lastShow),
      expression: "lastShow"
    }],
    staticClass: "last-sub",
    style: ({
      left: _vm.subLeft + 'px'
    })
  }, [_c('el-scrollbar', {
    staticStyle: {
      "height": "100%"
    }
  }, _vm._l((_vm.lastList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "last-sub-item",
      on: {
        "click": function($event) {
          return _vm.lastSubHandler(item)
        }
      }
    }, [_vm._v("\n      " + _vm._s(item.name) + "\n    ")])
  }), 0)], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a9e4379"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/category-menu.vue
// module id = 1575
// module chunks = 1